import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisHorizontalCircleFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M10.667 8c0 .75.5 1 1 1s1-.25 1-1-.5-1-1-1-1 .25-1 1M4.334 9c-.5 0-1-.25-1-1s.5-1 1-1 1 .25 1 1-.5 1-1 1M8 9c-.5 0-1-.25-1-1s.5-1 1-1 1 .25 1 1-.5 1-1 1"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
EllipsisHorizontalCircleFilledSize16Glyph.displayName = 'EllipsisHorizontalCircleFilledSize16Glyph';
